import axios from 'axios';

export const groupsService = {
    getGroups,
    getGroupById,
    addGroup,
    updateGroup,
    deleteGroup,
    getGroupChargers,
    attachChargerToGroup
}


async function getGroups() {
    return await axios.get('/groups');
}

async function getGroupById(groupId) {
    return await axios.get(`/Groups/${groupId}`);
}

async function addGroup(group) {
    return await axios.post('/Groups/CreateGroup/',group);
}

async function updateGroup(group) {
    return await axios.post('/Groups/update/',group);
}

async function attachChargerToGroup(chargerId, groupId, attach) {
    return await axios.put('/Groups/Attach', { chargerId, groupId, attach });
}

async function deleteGroup(groupId) {
    return await axios.delete(`/Groups/DeleteGroup/${groupId}`);
}

// Group Chargers
async function getGroupChargers() {
    return await axios.get('/Groups/Chargers');
}
export default groupsService;